import React, { useEffect, useMemo } from 'react'
import BlogList from './BlogList'
import { Col, Container, Pagination, Row } from 'react-bootstrap'
import { base_url, postHeader } from '../../../Helper/request'
import axios from 'axios'
import { useState } from 'react'
import Skeleton from 'react-loading-skeleton'
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom/dist'
import { useDispatch, useSelector } from 'react-redux'
import ResponsivePagination from 'react-responsive-pagination';

const Blog = ({ props }) => {
  const navigate = useNavigate()
  // const params = useSearchParams()
  const dispatch = useDispatch();
  const userdata = useSelector(state => state.persistedReducer.home.user)
  const isLike = useSelector(state => state.persistedReducer.home.isBlogLike)
  const [searchParams, setSearchParams] = useSearchParams();
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  // const [bloglist, setBloglist] = useState([]);
  const [blog_length, setBlog_length] = useState(null);
  const [pageNum, setPageNum] = useState([]);
  const [currentPage, setCurrentPage] = useState(parseInt(searchParams.get('p') || '1', pageNum));
  const [blogPerPage, setBlogPerPage] = useState(9);
  const [isBLike, setisBLike] = useState(0);
  const [like1, setLike1] = useState(false);

  // const pg = parseInt(searchParams.get('p') || '1', pageNum)
  useEffect(() => {
    blogList();
  }, [currentPage])


  const blogList = () => {
    // setData([])
    const data1 = {
      user_id: userdata?.user_id ? userdata?.user_id : "",
      category_id: null,
      limit: blogPerPage,
      offset: (currentPage - 1) * blogPerPage
    }
    axios.post(base_url + '/common/blog_list', data1, {
      headers: postHeader
    })
      .then(response => {
        setData([])
        if (response.data.status == 1) {
          setData(response.data.data)
          setPageNum([...Array(Math.ceil(response.data.total_rows / blogPerPage) + 1).keys()].slice(1))
          setCurrentPage(currentPage)
          // setBloglist(response.data.data)
          if (currentPage == 1) {
            navigate('/blog')
          } else {
            navigate(
              `/blog?p=${currentPage}`)
            if (window.location.pathname == `/blog?p=${currentPage}`) {
              setCurrentPage(currentPage)
            }
          }
          setLoader(true)
        } else {
          console.log(response.data.message)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  // useMemo(() => blogList, [like1])
  const lastBlog = currentPage * blogPerPage;
  const firstBlog = lastBlog - blogPerPage;
  // const currentBlogs = bloglist.slice(firstBlog, lastBlog);

  const onPrevPage = () => {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
      window.scrollTo(0, 50);
    }
  };

  const onNextPage = () => {
    if (currentPage !== pageNum.length) {
      setCurrentPage(currentPage + 1);
      window.scrollTo(0, 50);
    }
  };



  const hndleLike = (id, likeindex) => {
    setLike1(true)
    const data1 = {
      user_id: userdata?.user_id ?? "",
      blog_id: id
    }
    axios.post(base_url + '/common/blog_like', data1, {
      headers: postHeader
    })
      .then(response => {
        if (response.data.status == 1) {
          // blogList();
          // dispatch(isBlogLike(true))
          setisBLike(response.data.data)
          const bloglist = data.map((obj, index) => {
            if (index == likeindex) {
              return { ...obj, user_liked: response.data.data, total_liked: response.data.total }
            }
            return obj
          }

          );
          setData(bloglist)
          // const bloglists = data.map((obj, index) =>{
          //   if ( index == likeindex ) { 
          //     return {...obj, total_liked: response.data.total}
          //   }
          //     return obj 
          //   })
          // setData(bloglists)
        } else {
          console.log(response.data.message)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  const hndlick = (num) => {
    setCurrentPage(num);
    window.scrollTo(0, 60)
  }
  return (
    <>
      <div className='page-header custom-design-header'>
        <h1 className='page-title text-center text-uppercase mb-3'>Our Blog</h1>
        {/* <p className='text-center'>Lorem ipsum dolor sit amet consectetur adipisicing elit. In saepe atque sunt magnam et impedit </p> */}
      </div>

      <div className='blogLists mb-5'>
        <Container >
          <Row className='gy-5 mb-5'>
            {
              loader ?
                data.length > 0 && data?.map((e, i) => (
                  <Col lg={4} md={4} key={i}>
                    <BlogList
                      user_liked={e.user_liked}
                      is_liked={e.is_liked}
                      total_liked={e.total_liked}
                      total_comment={e.total_comment}
                      img={e?.blog_image}
                      slug={'/blog/' + e?.blog_url}
                      catSlug={'/category/' + e?.category_name.trimEnd().toLowerCase().replaceAll(" ", "-")}
                      category_name={e?.category_name}
                      catID={e?.category_id}
                      author="Admin"
                      title={e?.blog_name}
                      publish_date={e.publish_date}
                      blog_id={e.blog_id}
                      blogList={e}
                      b_index={i}
                      hndleLike={hndleLike}
                      isBLike={isBLike}
                    />
                  </Col>

                )) : Array(3).fill().map((e, i) => (
                  <Col lg={4} className='mb-3' md={4} key={i}> <Skeleton height={350} count={1} /></Col>
                ))
            }
          </Row>
          {/* <Pagination className="pagination-blog list-unstyled justify-content-center" >
            <Pagination.Prev onClick={onPrevPage} />
            {
              pageNum.map(num =>
                <Pagination.Item
                  className={currentPage === num ? 'active' : null}
                  onClick={() => hndlick(num)}
                  >
                  {num}
                  
                </Pagination.Item>)}
            <Pagination.Next onClick={onNextPage} />
          </Pagination> */}
          <Row className='justify-content-center'>
            <Col lg={6}>
              <ResponsivePagination
                current={currentPage}
                total={pageNum?.length}
                onPageChange={page => hndlick(page)}
              />
            </Col>
          </Row>

        </Container>

      </div>
    </>
  )
}

export default Blog